// extracted by mini-css-extract-plugin
module.exports = {"Etapa":"Etapa_Etapa__1Fg9r","Lighter":"Etapa_Lighter__mxbgC"};